import { NgModule }      from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { LabelModule } from 'libraries/service/label/label.module';
import { DateRangePipe } from './dateRange.pipe';

@NgModule({
    imports: [
        CommonModule,
        LabelModule,
    ],
    declarations: [
        DateRangePipe,
    ],
    exports: [
        DateRangePipe,
    ],
    providers: [
        DatePipe,
        DateRangePipe,
    ]
})
export class DateRangePipeModule {  }